import { render, staticRenderFns } from "./SubmitButtons.vue?vue&type=template&id=0083bfe7&"
import script from "./SubmitButtons.vue?vue&type=script&lang=js&"
export * from "./SubmitButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports